import React from "react";
import { Routes, Route } from "react-router-dom";
import NotFound from "../components/others/NotFound";
import ScrollToTop from "./ScrollToTop";
import HomeCero from "../themes/index-0/HomeCero";
import Primarios from "../pages/Primarios";
import Secundarios from "../pages/Secundarios";
import PriCarlosPaz from "../pages/PriCarlosPaz";
import PriSanPedro from "../pages/PriSanPedro";
import PriRamallo from "../pages/PriRamallo";
import PriCostaAtlantica from "../pages/PriCostaAtlantica";
import SecBrasil from "../pages/SecBrasil";
import SecCostaAtlantica from "../pages/SecCostaAtlantica";
import SecVillaCarlosPaz from "../pages/SecVillaCarlosPaz";
import SecBariloche from "../pages/SecBariloche";
import Contact from "../pages/Contacto";
import ContactoNuevaReunion from "../pages/ContactoNuevaReunion";

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomeCero />} />
        <Route path="/primarios" element={<Primarios />} />
        <Route path="/villa-carlos-paz" element={<PriCarlosPaz />} />
        <Route path="/san-pedro" element={<PriSanPedro />} />
        <Route path="/ramallo" element={<PriRamallo />} />
        <Route path="/costa-atlantica-primarios" element={<PriCostaAtlantica />} />
        <Route path="/secundarios" element={<Secundarios />} />
        <Route path="/brasil" element={<SecBrasil />} />
        <Route path="/costa-atlantica-secundarios" element={<SecCostaAtlantica />} />
        <Route path="/villa-carlos-paz-secundarios" element={<SecVillaCarlosPaz />} />
        <Route path="/bariloche" element={<SecBariloche />} />
        <Route path="/contacto" element={<Contact />} />
        <Route path="/quierounareunion" element={<ContactoNuevaReunion />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
